var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isHideRevenue !== undefined)?_c('div',{staticClass:"wrapper"},[(_vm.isHideRevenue)?_c('div',[_vm._v("本ページへのアクセス権がありません")]):_vm._e(),(_vm.form !== null && _vm.isHideRevenue === false)?_c('SimulationTemplate',{attrs:{"form":_vm.form}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }